import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/fb-marketplace-ads';

export default function Example() {
  return (
    <>
      <Head>
        <title>The Seller Guide to Using Facebook Marketplace Ads</title>
        <meta
          name='description'
          content='Learn everything you need to know about Facebook marketplace ads and how they can benefit you in turning leads into sales for your business.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/fb-marketplace-ads' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/fb-marketplace-ads' />
        <meta property='og:title' content='The Seller Guide to Using Facebook Marketplace Ads' />
        <meta
          property='og:description'
          content='Learn everything you need to know about Facebook marketplace ads and how they can benefit you in turning leads into sales for your business.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='April 8th, 2022' />
        <meta property='article:modified_time' content='April 8th, 2022' />
        <meta property='article:tag' content='Facebook Marketplace' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
